const dateSelectionViews = Object.freeze({hidden:"hidden", options: "options", custom: "custom"});

export default dateSelectionViews;